module.exports = "/_next/static/images/4e52ff72bf1243d7b8466fb5b2cc34b7-mulher-perfil-segurando-cartao-md@3x.jpg.webp";